import React from 'react';
import GenericSvgIcon from "@Icons/GenericSvgIcon";
import IconType from "@/types/Icon.type";

function IconMapStroke(props: IconType) {
    const {
        width = '16',
        height = '16',
        stroke = '#070c63',
        viewBox = '0 0 16 16',
        title = 'IconMapStroke',
        ...rest
    } = props

    return (
        <GenericSvgIcon
            width={width}
            height={height}
            stroke={stroke}
            viewBox={viewBox}
            title={title}
            {...rest}
            svgIconPath={(
                <path
                    d="m8.86111857 2.96658733-3.57938-2.28976955c-.14238-.07111284-.29968-.10721921-.45882-.10539067-.15915.00197108-.31554.04182707-.45618.11632957l-3.52937 2.36788169c-.0803.04253571-.14748.10614931-.19434.18399148-.04685.07784216-.0716.16698319-.0716.25784405v9.2428298c0 .0861913.02228.1709827.06471.2460752.04243.0749924.10355.1377861.17743.1822816.07387.0444956.15799.0690931.24419.0713929.0862.0023997.17154-.0175983.24773-.0578942l3.05688-1.9932994c.14178-.0750924.29957-.1149884.46002-.1162883s.31886.0359964.46185.1087891l3.49563 2.2810704c.14174.0721927.29866.1095889.45776.1089961.1591-.000607.3157-.0392032.4569-.1124958l3.60720003-2.3728612c.0813-.0421957.1494-.1058893.197-.1840814.0475-.0782922.0727-.1680831.0727-.2595739v-9.24036001c0-.08621132-.0223-.17097279-.0647-.24603524-.0424-.07505244-.1036-.13786612-.1774-.18234165-.0739-.04446552-.158-.06906304-.2442-.07142281-.0862-.00235976-.1716.01760823-.2478.05797417l-3.06250003 1.99541917c-.1404.07429252-.2966.11403852-.4555.11593833s-.31599-.03408657-.45821-.10499943zm.56745286.23341267v9.8m-4.42857143-12v10"
                    fill="none"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    transform="translate(1 1)"
                />
            )}
        />

    );
}

export default IconMapStroke;
